var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("main", { attrs: { id: "container-wrap" } }, [
    _c("section", { attrs: { id: "content" } }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { id: "promo4" } },
        [
          _vm.checkPromotion !== "membership"
            ? [
                _c("div", { staticClass: "top" }, [
                  _vm.checkPromotion === "251220"
                    ? _c("img", {
                        staticClass: "gift",
                        attrs: {
                          src: require("@/assets/membership/img/img-gift2.png"),
                          alt: "gift",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", [
                    _c("p", { staticClass: "title" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.checkPromotion === "251121"
                              ? "双12年终优惠活动"
                              : _vm.checkPromotion === "251220"
                              ? "寒假特别赠送"
                              : _vm.checkPromotion === "260126"
                              ? "轻松快乐寒假"
                              : ""
                          ) +
                          "\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "desc" }, [
                      _c("span", [
                        _vm._v(
                          "\n                                " +
                            _vm._s(
                              _vm.checkPromotion === "251121"
                                ? "（仅限11月21日-12月16日）"
                                : _vm.checkPromotion === "251220"
                                ? "（12月20日-1月25日）"
                                : _vm.checkPromotion === "260126"
                                ? "（仅限1月26日-2月26日）"
                                : ""
                            ) +
                            "\n                            "
                        ),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _vm.checkPromotion === "251220"
                  ? _c("img", {
                      staticClass: "gift",
                      attrs: {
                        src: require("@/assets/membership/img/img-gift2.png"),
                        alt: "gift",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "products" }, [
                  _c("div", { staticClass: "product no-padding" }, [
                    _vm.showBadge
                      ? _c("div", { staticClass: "add-badge badge-200" })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "product-header",
                        class: { "left-align": _vm.showBadge },
                      },
                      [
                        _c("p", [_vm._v("2年卡")]),
                        _vm._v(" "),
                        _c("p", [_vm._v("(2个孩子使用)")]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "product-body" },
                      [
                        _vm.showOriginalPrice
                          ? [
                              _c("div", { staticClass: "break-line" }),
                              _vm._v(" "),
                              _c("p", { staticClass: "price original" }, [
                                _vm._v("1188"),
                              ]),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _c("p", { staticClass: "price discount" }, [
                          _c("span", { staticClass: "value" }, [
                            _vm._v(
                              "\n                                    " +
                                _vm._s("988") +
                                "\n                                "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "price-desc new" }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s("加贈12个月") +
                              "\n                            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass: "price-desc sub",
                            class: { color: _vm.checkPromotion === "251220" },
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.checkPromotion === "251121" ||
                                    _vm.checkPromotion === "260126"
                                    ? "(每个孩子 0.45/天)"
                                    : _vm.checkPromotion === "251220"
                                    ? "送Orchard Toys配对和拼写1盒"
                                    : ""
                                ) +
                                "\n                            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.handleLinkClick("promotion", 0)
                              },
                            },
                          },
                          [_vm._v("立即购买")]
                        ),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "product" }, [
                    _vm.showBadge
                      ? _c("div", { staticClass: "add-badge badge-200" })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "product-header",
                        class: { "left-align": _vm.showBadge },
                      },
                      [
                        _c("p", [_vm._v("1年卡")]),
                        _vm._v(" "),
                        _c("p", [_vm._v("(2个孩子使用)")]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "product-body" },
                      [
                        _vm.showOriginalPrice
                          ? [
                              _c("div", { staticClass: "break-line" }),
                              _vm._v(" "),
                              _c("p", { staticClass: "price original" }, [
                                _vm._v("899"),
                              ]),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _c("p", { staticClass: "price discount" }, [
                          _c("span", { staticClass: "value" }, [
                            _vm._v(
                              "\n                                    " +
                                _vm._s("699") +
                                "\n                                "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "price-desc new" }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.checkPromotion === "260126"
                                  ? "加赠10个月"
                                  : "加贈9个月"
                              ) +
                              "\n                            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass: "price-desc sub",
                            class: { color: _vm.checkPromotion === "251220" },
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.checkPromotion === "251121" ||
                                    _vm.checkPromotion === "260126"
                                    ? "(每个孩子 0.55/天)"
                                    : _vm.checkPromotion === "251220"
                                    ? "送Orchard Toys配对和拼写1盒"
                                    : ""
                                ) +
                                "\n                            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.handleLinkClick("promotion", 1)
                              },
                            },
                          },
                          [_vm._v("立即购买")]
                        ),
                      ],
                      2
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "products" }, [
                  _c("div", { staticClass: "product no-padding" }, [
                    _vm.showBadge
                      ? _c("div", { staticClass: "add-badge" })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "product-header",
                        class: { "left-align": _vm.showBadge },
                      },
                      [
                        _c("p", [_vm._v("半年卡")]),
                        _vm._v(" "),
                        _c("p", [_vm._v("(2个孩子使用)")]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "product-body" },
                      [
                        _vm.showOriginalPrice
                          ? [
                              _c("div", { staticClass: "break-line" }),
                              _vm._v(" "),
                              _c("p", { staticClass: "price original" }, [
                                _vm._v("680"),
                              ]),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _c("p", { staticClass: "price discount" }, [
                          _vm._v(_vm._s("580")),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "price-desc new" }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.checkPromotion === "251121"
                                  ? "加赠5个月"
                                  : _vm.checkPromotion === "251220" ||
                                    _vm.checkPromotion === "260126"
                                  ? "加赠6个月"
                                  : "加赠1个月"
                              ) +
                              "\n                            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "price-desc sub" }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.checkPromotion === "251121"
                                  ? "(每个孩子 0.87/天)"
                                  : _vm.checkPromotion === "251220"
                                  ? "(每个孩子 1.14/天)"
                                  : "(每个孩子 0.75/天)"
                              ) +
                              "\n                            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.handleLinkClick("promotion", 2)
                              },
                            },
                          },
                          [_vm._v("立即购买")]
                        ),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "product" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _vm._m(2),
                    _vm._v(" "),
                    _c("div", { staticClass: "product-body" }, [
                      _c("div", { staticClass: "break-line" }),
                      _vm._v(" "),
                      _c("p", { staticClass: "price original" }, [
                        _vm._v("32"),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "price discount" }, [
                        _vm._v(_vm._s("9.9")),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "price-desc new hide" }),
                      _vm._v(" "),
                      _c("p", { staticClass: "price-desc sub" }, [
                        _vm._v("仅限新用户购买"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.handleLinkClick("promotion", 3)
                            },
                          },
                        },
                        [_vm._v("立即购买")]
                      ),
                    ]),
                  ]),
                ]),
              ]
            : _vm.type === "membership"
            ? [
                _c("p", { staticClass: "title" }, [_vm._v("续费专用")]),
                _vm._v(" "),
                _vm._m(3),
                _vm._v(" "),
                _c("div", { staticClass: "products" }, [
                  _c("div", { staticClass: "product" }, [
                    _vm._m(4),
                    _vm._v(" "),
                    _c("div", { staticClass: "product-body" }, [
                      _c("div", { staticClass: "break-line" }),
                      _vm._v(" "),
                      _c("p", { staticClass: "price original" }, [
                        _vm._v("1188"),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "price discount" }, [
                        _vm._v("708"),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "price-desc" }, [
                        _vm._v("(每个孩子 0.48/天)"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.handleLinkClick("membership", 0)
                            },
                          },
                        },
                        [_vm._v("立即购买")]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "product" }, [
                    _vm._m(5),
                    _vm._v(" "),
                    _c("div", { staticClass: "product-body" }, [
                      _c("div", { staticClass: "break-line" }),
                      _vm._v(" "),
                      _c("p", { staticClass: "price original" }, [
                        _vm._v("899"),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "price discount" }, [
                        _vm._v("499"),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "price-desc" }, [
                        _vm._v("(每个孩子 0.75/天)"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.handleLinkClick("membership", 1)
                            },
                          },
                        },
                        [_vm._v("立即购买")]
                      ),
                    ]),
                  ]),
                ]),
              ]
            : _vm.type === "new"
            ? [
                _c("p", { staticClass: "title" }, [_vm._v("新注册专项")]),
                _vm._v(" "),
                _vm._m(6),
                _vm._v(" "),
                _c("div", { staticClass: "products" }, [
                  _c("div", { staticClass: "product" }, [
                    _c("div", { staticClass: "add-badge badge-200" }),
                    _vm._v(" "),
                    _vm._m(7),
                    _vm._v(" "),
                    _c("div", { staticClass: "product-body" }, [
                      _c("div", { staticClass: "break-line" }),
                      _vm._v(" "),
                      _c("p", { staticClass: "price original" }, [
                        _vm._v("1188"),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "price discount" }, [
                        _vm._v("988"),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "price-desc new" }, [
                        _vm._v("+ 加赠 6个月"),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "price-desc sub" }, [
                        _vm._v("(每个孩子 0.5/天)"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.handleLinkClick("new", 0)
                            },
                          },
                        },
                        [_vm._v("立即购买")]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "product" }, [
                    _c("div", { staticClass: "add-badge badge-200" }),
                    _vm._v(" "),
                    _vm._m(8),
                    _vm._v(" "),
                    _c("div", { staticClass: "product-body" }, [
                      _c("div", { staticClass: "break-line" }),
                      _vm._v(" "),
                      _c("p", { staticClass: "price original" }, [
                        _vm._v("899"),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "price discount" }, [
                        _vm._v("699"),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "price-desc new" }, [
                        _vm._v("+ 加赠 3个月"),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "price-desc sub" }, [
                        _vm._v("(每个孩子 0.75/天)"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.handleLinkClick("new", 1)
                            },
                          },
                        },
                        [_vm._v("立即购买")]
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "products" }, [
                  _c("div", { staticClass: "product" }, [
                    _c("div", { staticClass: "add-badge badge-200" }),
                    _vm._v(" "),
                    _vm._m(9),
                    _vm._v(" "),
                    _c("div", { staticClass: "product-body" }, [
                      _c("div", { staticClass: "break-line" }),
                      _vm._v(" "),
                      _c("p", { staticClass: "price original" }, [
                        _vm._v("680"),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "price discount" }, [
                        _vm._v("480"),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "price-desc new" }, [
                        _vm._v("+ 加赠 1个月"),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "price-desc sub" }, [
                        _vm._v("(每个孩子 1.1/天)"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.handleLinkClick("new", 2)
                            },
                          },
                        },
                        [_vm._v("立即购买")]
                      ),
                    ]),
                  ]),
                ]),
              ]
            : _vm.type === "all"
            ? [
                _c("div", { staticClass: "products no-title" }, [
                  _c("div", { staticClass: "product" }, [
                    _c("div", { staticClass: "add-badge" }),
                    _vm._v(" "),
                    _vm._m(10),
                    _vm._v(" "),
                    _c("div", { staticClass: "product-body" }, [
                      _c("div", { staticClass: "break-line" }),
                      _vm._v(" "),
                      _c("p", { staticClass: "price original" }, [
                        _vm._v("1188"),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "price discount" }, [
                        _vm._v("1088"),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "price-desc new" }, [
                        _vm._v("+ 加赠 6个月"),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "price-desc sub" }, [
                        _vm._v("(每个孩子 0.6/天)"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.handleLinkClick("all", 0)
                            },
                          },
                        },
                        [_vm._v("立即购买")]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "product" }, [
                    _c("div", { staticClass: "add-badge" }),
                    _vm._v(" "),
                    _vm._m(11),
                    _vm._v(" "),
                    _c("div", { staticClass: "product-body" }, [
                      _c("div", { staticClass: "break-line" }),
                      _vm._v(" "),
                      _c("p", { staticClass: "price original" }, [
                        _vm._v("899"),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "price discount" }, [
                        _vm._v("799"),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "price-desc new" }, [
                        _vm._v("+ 加赠 3个月"),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "price-desc sub" }, [
                        _vm._v("(每个孩子 0.88/天)"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.handleLinkClick("all", 1)
                            },
                          },
                        },
                        [_vm._v("立即购买")]
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "products" }, [
                  _c("div", { staticClass: "product" }, [
                    _c("div", { staticClass: "add-badge" }),
                    _vm._v(" "),
                    _vm._m(12),
                    _vm._v(" "),
                    _c("div", { staticClass: "product-body" }, [
                      _c("div", { staticClass: "break-line" }),
                      _vm._v(" "),
                      _c("p", { staticClass: "price original" }, [
                        _vm._v("680"),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "price discount" }, [
                        _vm._v("580"),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "price-desc new" }, [
                        _vm._v("+ 加赠 1个月"),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "price-desc sub" }, [
                        _vm._v("(每个孩子 1.35/天)"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.handleLinkClick("all", 2)
                            },
                          },
                        },
                        [_vm._v("立即购买")]
                      ),
                    ]),
                  ]),
                ]),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _vm._m(13),
      _vm._v(" "),
      _vm._m(14),
    ]),
    _vm._v(" "),
    _c("footer", [
      _c("div", { staticClass: "container" }, [
        _c("p", { staticClass: "rights" }, [
          _vm._v("ⓒ 2021 Enuma, Inc. All Rights Reserved."),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("p", [_vm._v("深圳埃努码信息技术有限公司")]),
          _vm._v(" "),
          _c("p", { staticClass: "v-line" }),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: { cursor: "pointer" },
              on: {
                click: function ($event) {
                  return _vm.onClickFooterLink(0)
                },
              },
            },
            [_vm._v("粤ICP备2022075939号")]
          ),
          _vm._v(" "),
          _c("p", { staticClass: "v-line" }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "ovcn",
              staticStyle: { cursor: "pointer" },
              on: {
                click: function ($event) {
                  return _vm.onClickFooterLink(1)
                },
              },
            },
            [
              _c("img", {
                attrs: {
                  src: require("@/assets/common/icn_beiangovcn.png"),
                  alt: "",
                },
              }),
              _vm._v(" "),
              _c("p", [_vm._v("京公网安备 11010502050400号")]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "深圳市南山区南头街道大汪山社区桃园东路1号 西海明珠花园F座2117-1"
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { attrs: { id: "article" } }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "text-box" }, [
          _c("p", { staticClass: "title" }, [
            _vm._v(
              "\n                        美国教研团队，专门为母语非英语的孩子研发；\n                    "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "title" }, [
            _vm._v(
              "\n                        包含听、说、读、写的全方位能力提升；\n                    "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "title" }, [
            _vm._v(
              "\n                        原版启蒙学习规划，全面且高效的学习方式；\n                    "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "title" }, [
            _vm._v(
              "\n                        一个会员即可享受自然拼读、分级阅读、场景视频、语法\n                    "
            ),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "add-badge blank" }, [
      _c("p", [_vm._v("新用户"), _c("br"), _vm._v("专享")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "product-header left-align" }, [
      _c("p", [_vm._v("7日卡")]),
      _vm._v(" "),
      _c("p", [_vm._v("(2个孩子使用)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "desc" }, [
      _c("span", [_vm._v("减轻压力 续航学习时间!")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "product-header" }, [
      _c("p", [_vm._v("2年卡")]),
      _vm._v(" "),
      _c("p", [_vm._v("(2个孩子使用)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "product-header" }, [
      _c("p", [_vm._v("1年卡")]),
      _vm._v(" "),
      _c("p", [_vm._v("(2个孩子使用)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "desc" }, [
      _c("span", [_vm._v("注册7日内下单, ")]),
      _vm._v(" "),
      _c("span", [_vm._v("立减 ¥200!")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "product-header left-align" }, [
      _c("p", [_vm._v("2年卡")]),
      _vm._v(" "),
      _c("p", [_vm._v("(2个孩子使用)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "product-header left-align" }, [
      _c("p", [_vm._v("1年卡")]),
      _vm._v(" "),
      _c("p", [_vm._v("(2个孩子使用)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "product-header left-align" }, [
      _c("p", [_vm._v("半年卡")]),
      _vm._v(" "),
      _c("p", [_vm._v("(2个孩子使用)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "product-header left-align" }, [
      _c("p", [_vm._v("2年卡")]),
      _vm._v(" "),
      _c("p", [_vm._v("(2个孩子使用)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "product-header left-align" }, [
      _c("p", [_vm._v("1年卡")]),
      _vm._v(" "),
      _c("p", [_vm._v("(2个孩子使用)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "product-header left-align" }, [
      _c("p", [_vm._v("半年卡")]),
      _vm._v(" "),
      _c("p", [_vm._v("(2个孩子使用)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { attrs: { id: "promo2" } }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "qr-code" }, [
          _c("h2", [_vm._v("关注官方公众号")]),
          _vm._v(" "),
          _c("p", [
            _vm._v("了解更多"),
            _c("span", [_vm._v("优惠")]),
            _vm._v("活动"),
          ]),
          _vm._v(" "),
          _c("img", {
            staticClass: "img-qrcode",
            attrs: { src: require("@/assets/membership/img/img-qrcode.png") },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "vertical-line" }),
        _vm._v(" "),
        _c("div", { staticClass: "qr-code" }, [
          _c("h2", [_vm._v("官方企微客服")]),
          _vm._v(" "),
          _c("p", [_vm._v("1v1人工客服")]),
          _vm._v(" "),
          _c("img", {
            staticClass: "img-qqcode",
            attrs: { src: require("@/assets/membership/img/img-qqcode2.png") },
          }),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { attrs: { id: "promo3" } }, [
      _c("div", { staticClass: "container" }, [
        _c("h2", { staticClass: "title" }, [_vm._v("用户购前须知")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "支持本页所购商品，下单后7日内无理由退款。超出7日后，不支持退款申请。"
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "购买年卡赠送的练习册及其他周边产品一经拆封，不支持退货退款。"
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v("希注册用户体验会员期间购买并激活年卡，您的使用时间将累计。"),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "收到激活码后请在30天内完成激活兑换，如过期未激活者码将失效，请及时联系官方客服咨询解决方案。"
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "会员一经激活则正式生效，请确认您激活时登陆使用的账号是否准确，且该账号为您个人使用。如使用非法账号或非个人账号造成的经济损失将由您自行承担。"
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "都都GO（原都都英语）要求设备为支持 IOS 15及以上，Android 10及以上的手机或平板电脑、学习机，如使用期间有卡顿、启动闪退等问题，请及时升级您的设备系统。"
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "都都会员支持多平台互通，即不论您是安卓设备还是苹果设备，均可登陆同一账号。"
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "都都会员仅支持最多不超过5台设备上同时登录。多设备登录极易发生存档丢失、学习进度丢失及其它错误。建议您使用时只在一台设备上进行。"
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v("为了保证您的财产安全，请不要将您的账号分享给陌生人使用。"),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "我们将严厉打击盗版、倒卖非法账号、倒卖激活码的不法行为，同时都都会员不允许一个账号分销给多个用户使用，一经发现将对非法账号和激活码进行封号处理。非正式途径购买账号或激活码造成的经济损失，将由您自行承担。"
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "欢迎关注官方微信公众号：都都APP ，如有疑问可咨询官方人工客服（关注微信公众号-转人工客服即可），或官方举报投诉电话：（+86）18810316494."
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }